const items = [
  { icon: "ri-smartphone-line", label: "Mobile Technology" },
  { icon: "ri-computer-line", label: "Laptops" },
  { icon: "ri-plug-line", label: "Everyday Accessories" },
  { icon: "ri-map-pin-line", label: "Liverpool Retail" },
];

export default function TrustStrip() {
  return (
    <section className="border-b border-foreground-200 bg-foreground-950">
      <div className="container-x grid grid-cols-2 gap-6 py-8 md:grid-cols-4 md:py-10">
        {items.map((it) => (
          <div key={it.label} className="flex items-center gap-3">
            <span className="flex h-11 w-11 items-center justify-center rounded-full border border-foreground-700 text-primary-400">
              <i className={`${it.icon} text-xl`}></i>
            </span>
            <span className="font-heading text-sm text-background-50 md:text-base">{it.label}</span>
          </div>
        ))}
      </div>
    </section>
  );
}